import { useEffect } from "react";
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, onMessage } from 'firebase/messaging';

const firebaseConfig = {
    apiKey: "AIzaSyAwqgAFMBMoDvki7tL8sZuvI_UG-2a1XOg",
    authDomain: "starnex-app.firebaseapp.com",
    projectId: "starnex-app",
    storageBucket: "starnex-app.appspot.com",
    messagingSenderId: "1001650914971",
    appId: "1:1001650914971:web:e896e60940d90a75eb283e",
    measurementId: "G-B0V5QFC6LC"
};

const app = initializeApp(firebaseConfig);
export const messaging = async () => (await isSupported()) ? getMessaging(app) : null;

export const getFcmToken = async () => {
    try {
        const fcmToken = await getToken(messaging);
        return fcmToken;
    } catch (err) {
        return undefined;
    }
}

export const NotificationContants = {
    BackgroundMessage: "BackgroundMessage",
    ForegroundMessage: "ForegroundMessage",
}

const NotificationHandler = ({ children }) => {

    useEffect(() => {
        const handleClick = (event) => {
            console.log("On notification click: ", event.notification.tag);
            event.notification.close();
        }

        document?.addEventListener("notificationclick", handleClick);
   
        return () => document?.removeEventListener('notificationclick', handleClick);
    }, []);

    useEffect(() => {
        const handleClick = (event) => {
            console.log("On notification close: ", event.notification.tag);
        }

        document?.addEventListener("notificationclose", handleClick);
   
        return () => document?.removeEventListener('notificationclose', handleClick);
    }, []);

    useEffect(() => {
        const unsubscribe = onMessage(messaging, async (remoteMessage) => {
            console.log('Message handled in the foreground!', remoteMessage);
            // dispatch(setForegroundNotification(remoteMessage));
            localStorage.setItem(NotificationContants.ForegroundMessage, JSON.stringify(remoteMessage));
            const notify = new Notification(remoteMessage.notification.title, {
                body: remoteMessage.notification?.body
            })
        });
        return unsubscribe;
    }, []);

    useEffect(() => {
        const checkActiveNotifications = async () => {
            // const backgroundNotification = await AsyncStorage.getItem('Active-Background-Notification');
            // if (backgroundNotification) dispatch(setForegroundNotification(backgroundNotification));
            // const foregroundNotification = await AsyncStorage.getItem('Active-Foreground-Notification');
            // if (foregroundNotification) dispatch(setForegroundNotification(foregroundNotification));
        }
        checkActiveNotifications()
    }, [])

    return children;
}

export default NotificationHandler;